import Modal from "react-modal";
import React, { useState } from "react";
import Select from "components/Select";
import { getPaymentReports } from "services/ReportServices";
import { fireAlert, fireToast } from "services/sweetAlertConfig";
import { IPoliceman } from "interfaces/Policeman";
import Input from "../../Input";
import { parseDate } from "utils/parseDate";

import * as S from "./styles";
import { useDataList } from "hooks/useDataList";

interface ModalProps {
  modalIsOpen: boolean;
  setIsOpen: (value: boolean) => void;
}

Modal.setAppElement("#root");

export default function ExportFinancialReportModal({
  modalIsOpen,
  setIsOpen,
}: ModalProps) {
  function closeModal() {
    setIsOpen(false);
  }
  const [start, setStart] = useState<Date>();
  const [finish, setFinish] = useState<Date>();
  const [policeman, setPoliceman] = useState<string>();
  const [requesting, setRequesting] = useState<boolean>(false);

  function requestReport() {
    setRequesting(true);

    getPaymentReports({
      policeman,
      start,
      finish,
    })
      .then(async (res) => {
        const file = new Blob([res.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);

        setRequesting(false);

        fireToast("Relatório gerado com sucesso");
      })
      .catch((err) => {
        if (err.response.status === 404) {
          fireAlert(
            "error",
            "Nenhum relatório encontrado",
            "Nenhum relatório encontrado com os parametros"
          );
        } else {
          fireAlert("error", "Não foi possível gerar o relatório");
        }
        setRequesting(false);
      });
  }

  const { data } = useDataList<IPoliceman>({
    queryKey: 'listAllPolicemen',
    route: 'policemen',
    filter: {
      params: [{ payments: { id: "not(isNull)" } }],
      relations: { user: true, payments: true },
      notPage: true,
    }
  });

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentElement={(props, children) => (
        <S.ActiveContent {...props}>{children}</S.ActiveContent>
      )}
      overlayElement={(props, contentElement) => (
        <S.ActiveOverlay {...props}>{contentElement}</S.ActiveOverlay>
      )}
    >
      <S.Content>
        <S.Title>Exportar relatório</S.Title>
        <p>
          Selecione um pronta-resposta para gerar seu relatório financeiro
          completo.
        </p>
        <Select
          containerClassName="select-container"
          id="policeman"
          name="policeman"
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
            setPoliceman(event.target.value);
          }}
          label="Adicionar Pronta resposta"
          required={true}
          placeholder="Selecione uma opção"
        >
          <option value="Padrão">Selecione um Pronta Resposta</option>
          {data?.items?.map((policeman) => {
            return (
              <option key={policeman.id} value={policeman.id}>
                {policeman.user.name}
              </option>
            );
          })}
        </Select>
        <Input
          id="start"
          name="start"
          required
          type="Date"
          label="Data Inicial"
          onChange={(e) => {
            parseDate(setStart, e.target.value);
          }}
        />
        <Input
          id="finish"
          name="finish"
          required
          type="Date"
          label="Data Final"
          onChange={(e) => {
            parseDate(setFinish, e.target.value);
          }}
        />
        <S.ActiveConfirmButton
          disabled={requesting}
          onClick={() => requestReport()}
          type="button"
        >
          Gerar relatório
        </S.ActiveConfirmButton>
      </S.Content>
    </Modal>
  );
}
